import {
  Component,
  effect,
  EventEmitter,
  inject,
  input,
  Output
} from '@angular/core';
import { FadeInAnimator } from '@libs/common-animations';
import { MenuItem, MenuItemCommandEvent } from 'primeng/api';
import { TaxonomyAction } from '../../models/TaxonomyAction';
import { TaxonomyFeature } from '../../models/TaxonomyFeature';
import { TaxonomyTab } from '../../models/TaxonomyTab';
import { CampaignTableService } from '../../services/campaign-table.service';
import { TaxonomyUiConstants } from '../../taxonomy-ui/taxonomy-ui.constants';
import { CampaignTableConstants } from './campaign-table.constants';

@Component({
  selector: 'lib-taxonomy-campaign-table',
  templateUrl: './campaign-table.component.html',
  styleUrls: ['./campaign-table.component.scss'],
  animations: [FadeInAnimator.fade(TaxonomyUiConstants.defaultDurationInMillis)]
})
export class CampaignTableComponent {
  clientId = input(0);
  brandId = input(0);
  @Output() applyAIRecommendations = new EventEmitter<{
    action: TaxonomyAction;
  }>();

  @Output() updateDimensionMapping = new EventEmitter();

  readonly campaignTableService = inject(CampaignTableService);

  constructor() {
    effect(() => {
      this.campaignTableService.clientId = this.clientId();
      this.campaignTableService.brandId = this.brandId();
      this.campaignTableService.initializeComponent();
    });
  }

  public getCampaignActions(): MenuItem[] {
    let actions: MenuItem[] = [];
    if (this.campaignTableService.activeTab === TaxonomyTab.unmapped) {
      if (this.campaignTableService.viewFor === TaxonomyFeature.AI) {
        actions = CampaignTableConstants.aiRecommendationsCampaignActions;
      } else {
        actions = CampaignTableConstants.unmappedCampaignActions;
      }
    } else if (
      [TaxonomyTab.mapped, TaxonomyTab.underProcessing].includes(
        this.campaignTableService.activeTab
      )
    ) {
      actions = CampaignTableConstants.mappedCampaignActions;
    }
    actions.forEach((action) => {
      action.command = (event: MenuItemCommandEvent) => {
        this.evaluateAction(event);
      };
    });
    return actions;
  }

  public evaluateAction(event: MenuItemCommandEvent) {
    switch (event.item?.id) {
      case 'approve-mapping':
        this.campaignTableService.setSelectedActionCampaignToOverride();
        this.applyAIRecommendations.emit({
          action: TaxonomyAction.APPROVE as TaxonomyAction
        });
        break;
      case 'unmap-campaign':
        this.campaignTableService.setSelectedActionCampaignToOverride();
        this.updateDimensionMapping.emit({
          channel: TaxonomyUiConstants.unmappedValue,
          tactic: TaxonomyUiConstants.unmappedValue,
          segment: TaxonomyUiConstants.unmappedValue,
          action: TaxonomyAction.UNMAP as TaxonomyAction
        });
        break;
      case 'edit-mapping':
        this.campaignTableService.setSelectedActionCampaignToOverride();
        this.campaignTableService.changeActionStep('override');
        break;
      default:
        break;
    }
  }
}
